import { getFilenameFromUrl } from '#pplx/frontend/apps/ask/canvas-shared/AssetMenuItemsShared.js';
import { getAssetDownloadFilename, getAssetThumbnailPreviewUrl, getFirstAssetPreviewInfoUrl, } from '#pplx/frontend/apps/ask/canvas-shared/useAssetInfo.js';
import { isImage } from '#pplx/frontend/common/files/images.js';
import { getImageDownloadFilename, getMimeTypeFromUrl } from '#pplx/frontend/common/files/urls.js';
export function getMediaAssetInfoKey(mediaInfo) {
    return `${mediaInfo.type}:${mediaInfo.url}`;
}
function isMediaAssetInfo(media) {
    return ('type' in media &&
        (media.type === 'image' || media.type === 'video') &&
        typeof media.url === 'string' &&
        media.url.trim().length > 0);
}
export function getLightboxMediaInfo(media) {
    return isMediaAssetInfo(media) ? media : getConversationMediaAssetInfo(media);
}
export function getLightboxMediaItems(gallery) {
    const seen = new Set();
    return gallery.flatMap((item) => {
        const info = getLightboxMediaInfo(item);
        if (!info)
            return [];
        const key = getMediaAssetInfoKey(info);
        if (seen.has(key))
            return [];
        seen.add(key);
        return [info];
    });
}
export function getAttachmentMediaInfo(url) {
    const filename = getFilenameFromUrl(url);
    if (isImage(url)) {
        return { type: 'image', url, filename: filename || 'image.jpg' };
    }
    if (getMimeTypeFromUrl(url).startsWith('video/')) {
        return { type: 'video', url, filename: filename || 'video.mp4' };
    }
    return null;
}
export function getUploadedMediaInfo(type, url, name) {
    return { type, url, title: name, filename: name, downloadFromSignedUrl: true };
}
function inferFilename(asset, mediaUrl, fallback) {
    const downloadFilename = getAssetDownloadFilename(asset);
    if (downloadFilename) {
        const filename = asset.asset_type === 'GENERATED_IMAGE'
            ? getImageDownloadFilename(mediaUrl, downloadFilename)
            : downloadFilename;
        return filename.includes('.') ? filename : fallback;
    }
    const urlFilename = getFilenameFromUrl(mediaUrl);
    return urlFilename !== mediaUrl && urlFilename.includes('.') ? urlFilename : fallback;
}
export function getMediaAssetInfo(asset) {
    switch (asset.asset_type) {
        case 'GENERATED_IMAGE':
            if (!asset.generated_image?.url)
                return null;
            return {
                type: 'image',
                url: asset.generated_image.url,
                filename: inferFilename(asset, asset.generated_image.url, 'image.jpg'),
                assetType: asset.asset_type,
                assetUUID: asset.uuid,
            };
        case 'CHART':
            if (!asset.chart?.url)
                return null;
            return {
                type: 'image',
                url: asset.chart.url,
                filename: inferFilename(asset, asset.chart.url, 'image.jpg'),
                assetType: asset.asset_type,
                assetUUID: asset.uuid,
            };
        case 'SCREENSHOT':
            if (!asset.screenshot?.url)
                return null;
            return {
                type: 'image',
                url: asset.screenshot.url,
                filename: inferFilename(asset, asset.screenshot.url, 'image.jpg'),
                assetType: asset.asset_type,
                assetUUID: asset.uuid,
            };
        case 'GENERATED_VIDEO': {
            if (!asset.generated_video?.url)
                return null;
            const posterUrl = getAssetThumbnailPreviewUrl(asset) ??
                asset.screenshot?.url ??
                getFirstAssetPreviewInfoUrl(asset);
            return {
                type: 'video',
                url: asset.generated_video.url,
                posterUrl,
                filename: inferFilename(asset, asset.generated_video.url, 'video.mp4'),
                assetType: asset.asset_type,
                assetUUID: asset.uuid,
            };
        }
        default:
            return null;
    }
}
// Conversation charts retain their canvas editing controls.
export function getConversationMediaAssetInfo(asset) {
    return asset.asset_type === 'CHART' ? null : getMediaAssetInfo(asset);
}
export function assetLightboxOpenedEvent(media, reason) {
    return {
        event: 'asset lightbox opened',
        data: {
            reason,
            assetType: media.assetType,
            assetUUID: media.assetUUID,
        },
    };
}
/** An uploaded attachment image, saved under its original name. */
//# sourceMappingURL=mediaAssetInfo.js.map